// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__h7djm","loading-icon":"Loading_loading-icon__o9Tyt"};